import {
  CASE_GET_BY_CASE_ID_SUCCESS,
  CASE_GET_BY_USER_SUCCESS,
  SET_CURRENT_CASE_ID,
  SET_CURRENT_TOPIC_ID,
  SET_ROOT_APP,
  MESSAGING_TOPIC_ADD_SUCCESS,
  SET_CURRENT_EVENT_ID,
  SET_SCROLL_TO_DATE,
  FB_PROFILE_OWN_USER_UPDATED_SUCCESS,
  AUTH_USER_SUCCESS,
  CLEAR_ALL_STATE,
  COLD_START_FINISHED,
  CASE_ADD_SUCCESS,
  SET_LANGUAGE_PREF,
  UNAUTH_USER,
  WEBSOCKET_UPDATE_TIMESTAMP,
  SET_CURRENT_TAB,
  SET_WS_CONNECTED,
  INVITES_GET_ACCEPT_REQUEST,
  INVITES_POST_ACCEPT_SUCCESS,
  INVITE_AUTH_DETAILS_SUCCESS,
  RESET_INVITES_STATE,
  INVITE_GUID,
} from '../actions/actionTypes';

import { HOME_TAB } from '../constants/tabs';

const INITIAL_STATE = {
  currentCaseId: null,
  newCaseId: null,
  currentTopicId: null,
  currentEmployerTopicId: null,
  currentOnCallTopicId: null,
  currentEventId: null,
  shouldScrollToDate: null,
  locale: 'en-US',
  coldStartFinished: false,
  latestWebSocketTimestamp: null,
  currentTabIndex: HOME_TAB,
  wsConnected: false,
  pendingInviteGuid: null,
  authFormPrefills: null,
  wasLoggedIn: false,
};

function applicationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_WS_CONNECTED:
      return {
        ...state,
        wsConnected: action.payload,
      };
    case SET_CURRENT_TAB:
      return {
        ...state,
        currentTabIndex: action.payload,
      };
    case COLD_START_FINISHED:
      return {
        ...state,
        coldStartFinished: true,
      };
    case SET_LANGUAGE_PREF:
      return {
        ...state,
        locale: action.payload,
      };
    case CASE_ADD_SUCCESS:
      return {
        ...state,
        newCaseId: action.payload.caseId,
      };
    case INVITE_GUID:
      return {
        ...state,
        pendingInviteGuid: action.payload.guid,
      };
    case INVITE_AUTH_DETAILS_SUCCESS:
      const email = action.payload.email || null;
      const username = action.payload.username || null;
      const employerType = action.payload.employerType || null;
      const employerMode = !!employerType;
      return {
        ...state,
        pendingInviteGuid: action.payload.pendingInviteGuid,
        authFormPrefills: {
          email,
          username,
          employerType,
          employerMode,
        },
      };
    case INVITES_GET_ACCEPT_REQUEST:
      return {
        ...state,
        pendingInviteGuid: null,
      };
    case RESET_INVITES_STATE:
      return {
        ...state,
        pendingInviteGuid: null,
        authFormPrefills: null,
      };

    case INVITES_POST_ACCEPT_SUCCESS:
      // console.info('INVITES_POST_ACCEPT_SUCCESS', action.payload);
      return {
        ...state,
        newCaseId: action.payload.caseId,
      };
    case CASE_GET_BY_CASE_ID_SUCCESS:
      const caseAddedByUser = state.newCaseId && state.newCaseId == action.payload.caseId;
      // console.info('CASE_GET_BY_CASE_ID_SUCCESS');

      // if this case was just added by this user then make it the current case
      // or if there is no currentCaseId
      if (!caseAddedByUser && !!state.currentCaseId) return state;
      const currentTopicId =
        state.currentCaseId === action.payload.caseId ? state.currentTopicId : null;
      return {
        ...state,
        currentCaseId: action.payload.caseId,
        newCaseId: null,
        currentTopicId,
        shouldScrollToDate: new Date().toISOString(),
      };
    case SET_CURRENT_CASE_ID:
      return {
        ...state,
        currentCaseId: action.payload.currentCaseId,
        currentTopicId: action.payload.currentTopicId,
        currentEventId: action.payload.currentEventId,
        shouldScrollToDate: action.payload.shouldScrollToDate,
      };
    case MESSAGING_TOPIC_ADD_SUCCESS:
      let currentTopicState = {};
      if (action.payload.caseId) {
        currentTopicState = { currentTopicId: action.payload.topicId };
      } else if (action.payload.employerId) {
        currentTopicState = { currentEmployerTopicId: action.payload.topicId };
      }
      return {
        ...state,
        ...currentTopicState,
      };
    case SET_CURRENT_TOPIC_ID:
      return {
        ...state,
        ...action.payload,
      };
    case SET_CURRENT_EVENT_ID:
      return { ...state, currentEventId: action.payload || null };
    case SET_SCROLL_TO_DATE:
      return { ...state, shouldScrollToDate: action.payload || null };
    case SET_ROOT_APP:
      return { ...state, rootApp: action.payload };
    case FB_PROFILE_OWN_USER_UPDATED_SUCCESS:
    case AUTH_USER_SUCCESS:
      return {
        ...state,
        locale: action.payload.locale,
        wasLoggedIn: true,
      };
    case CASE_GET_BY_USER_SUCCESS:
      const updateFields = {};
      if (action.payload.entities.userProfile?.locale) {
        updateFields.locale = action.payload.entities.userProfile?.locale;
      }
      return {
        ...state,
        ...updateFields,
        lastFileTimestamp: new Date().getTime(),
      };
    case UNAUTH_USER:
      return {
        ...INITIAL_STATE,
        locale: state.locale || INITIAL_STATE.locale,
        pendingInviteGuid: state.pendingInviteGuid || INITIAL_STATE.pendingInviteGuid,
        authFormPrefills: state.authFormPrefills || INITIAL_STATE.authFormPrefills,
        wasLoggedIn: state.wasLoggedIn || INITIAL_STATE.wasLoggedIn,
      };
    case CLEAR_ALL_STATE:
      return {
        ...INITIAL_STATE,
        locale: state.locale || INITIAL_STATE.locale,
        pendingInviteGuid: state.pendingInviteGuid || INITIAL_STATE.pendingInviteGuid,
        authFormPrefills: state.authFormPrefills || INITIAL_STATE.authFormPrefills,
      };
    case WEBSOCKET_UPDATE_TIMESTAMP:
      return {
        ...state,
        latestWebSocketTimestamp: action.payload,
      };
    default:
      return state;
  }
}

export default applicationReducer;
